import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessesTrustUs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <rect width={80} height={80} fill="#1E6CE1" rx={40} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M31 38h-5.8c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C22 39.52 22 40.08 22 41.2V58m27-20h5.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C58 39.52 58 40.08 58 41.2V58m-9 0V28.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C45.96 22 44.84 22 42.6 22h-5.2c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C31 25.04 31 26.16 31 28.4V58m29 0H20m18-28h4m-4 8h4m-4 8h4"
    />
  </svg>
);
export default SvgBusinessesTrustUs;
